// extracted by mini-css-extract-plugin
export var brand = "_9n-9";
export var compact = "_9n-6";
export var extraSmall = "_9n-7";
export var icon = "_9n-0";
export var large = "_9n-4";
export var light = "_9n-1";
export var medium = "_9n-5";
export var outline = "_9n-b";
export var primaryDark = "_9n-a";
export var primaryLight = "_9n-8";
export var primaryModern = "_9n-c";
export var success = "_9n-2";
export var successSolid = "_9n-3";